import React, { FC } from 'react';
import { NumericFormat } from 'react-number-format';
import { FilledInputProps, InputAdornment, TextField } from '@mui/material';
import _ from 'lodash';

interface PercentageFieldText {
  label: string;
  fieldName: string;
  formik: any;
  placeholder?: string;
  inputProps?: Partial<FilledInputProps>;
  disabled?: boolean;
  size?: 'small' | 'medium';
  hideHelperText?: boolean;
  margin?: 'dense' | 'normal' | 'none';
}

export const PercentageFieldText: FC<PercentageFieldText> = ({
  label,
  fieldName,
  formik,
  placeholder,
  disabled,
  size,
  hideHelperText,
  margin = 'normal',
}) => {
  const value = _.get(formik.values, fieldName);
  const errors = _.get(formik.errors, fieldName);
  const touched = _.get(formik.touched, fieldName);

  return (
    <NumericFormat
      customInput={TextField}
      label={label}
      type="text"
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      value={value}
      margin={margin}
      onValueChange={(values) => {
        formik.setFieldValue(fieldName, values.floatValue);
      }}
      error={touched && Boolean(errors)}
      helperText={!hideHelperText ? (touched && errors) ?? ' ' : ''}
      disabled={disabled}
      valueIsNumericString={true}
      thousandSeparator={true}
      size={size}
      inputProps={{ 'data-cy': fieldName + '-field' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 1 }}>
            %
          </InputAdornment>
        ),
      }}
    />
  );
};
